export default "__VITE_ASSET__B$cU6fMN__"